import {
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_MONTHLY_SCAN_STATS_REQUEST,
  GET_MONTHLY_SCAN_STATS_SUCCESS,
  GET_MONTHLY_SCAN_STATS_FAILURE,
  CLEAR_DASHBOARD_DATA
} from '../../constants/dashboardConstant/dashboardConstants';
import { LOGOUT_SUCCESS } from '../../constants/authConstants';

const initialState = {
  stats: null,
  loading: false,
  error: null,
  monthlyStats: null,
  monthlyLoading: false,
  monthlyError: null
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_STATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
        error: null
      };
    case GET_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_MONTHLY_SCAN_STATS_REQUEST:
      return {
        ...state,
        monthlyLoading: true,
        monthlyError: null
      };
    case GET_MONTHLY_SCAN_STATS_SUCCESS:
      return {
        ...state,
        monthlyLoading: false,
        monthlyStats: action.payload,
        monthlyError: null
      };
    case GET_MONTHLY_SCAN_STATS_FAILURE:
      return {
        ...state,
        monthlyLoading: false,
        monthlyError: action.payload
      };
    case CLEAR_DASHBOARD_DATA:
    case LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default dashboardReducer;